<template>
    <span id="why-main">
        <div class="touple">
            <div @click="openLink('https://www.npr.org/sections/health-shots/2019/01/30/690066777/study-found-vaping-beat-traditional-smoking-cessation-options')" class="card" :style="{backgroundImage: `url('${require('../assets/stock/freedomblur.jpg')}')`}">
                <h3>Conquer Addiction</h3>
            </div>
            <div @click="openLink('https://www.nerdwallet.com/blog/health/medical-costs/ecigarettes-vapes-smoking/')" class="card" :style="{backgroundImage: `url('${require('../assets/stock/savingsblur.jpg')}')`}">
                <h3>Save Money</h3>
            </div>
        </div>
		<div class="touple solo">
			<div @click="openLink('https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5732188/')" class="card" :style="{backgroundImage: `url('${require('../assets/stock/breathblurgray.jpg')}')`}">
				<h3>Breathe Easier</h3>
			</div>
		</div>
    </span>
</template>

<script>
export default {
    methods: {
        openLink(link) {
            window.open(link, '_blank')
        }
    }
}
</script>

<style lang="scss">
    #why-main {
		margin-bottom: 60px;
        display: flex;
        flex-direction: column;
        align-items: center;
		.card {
			cursor: pointer;
		}
    }
</style>
